import type { MemberLevel } from '@growup/accounts-shared';
import { StatusBadge, type StatusTone } from '@growup/ui';

import { LEVEL_LOOK } from './labels';

const TONE: Record<MemberLevel, StatusTone> = {
  user: 'neutral',
  member: 'info',
  associate: 'success',
};

export function LevelBadge({ level }: { level: MemberLevel }) {
  const look = LEVEL_LOOK[level];
  return (
    <StatusBadge tone={TONE[level]} symbol={look.symbol}>
      {look.label}
    </StatusBadge>
  );
}
